<template>
  <div>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-data-table
      :headers="headers"
      :items="clientes"
      item-key="name"
      class="elevation-1"
      :search="search"
      :loading="loading"
    >

    <template v-slot:top>
        <v-row
          class="pa-4"
        >
        <v-col>
            <v-btn
              color="primary"
              :loading="isLoadingDownload"
            @click="exportarExcel"
            >
              Descargar data
              <v-icon> mdi-download </v-icon>
            </v-btn>
        </v-col>
          <v-col
            class="py-0 my-0"
          >
            <v-text-field
              v-model="search"
              label="Buscar en entidad tecnica..."
              outlined
            />
          </v-col>
          
        </v-row>
        
      </template>

      <template v-slot:[`item.fecha_ultima_visita`]="{ item }">
  
        {{ computedDate(item.fecha_ultima_visita) }}

      </template>

      <template v-slot:[`item.accions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              @click="editarCliente(item)"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip 
          v-if="isAdmin"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="dialogDelete(item)"
            >
              mdi-trash-can-outline
            </v-icon>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2 ml-2"
              v-bind="attrs"
              @click="agregarContactosCliente(item)"
              v-on="on"
            >
              mdi-card-account-phone
            </v-icon>
          </template>
          <span>Contactos</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="verificarDireccion(item)"
            >
                mdi-clipboard-text-outline
            </v-icon>
          </template>
          <span>Prospección</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="comentariosCliente(item)"
            >
              mdi-comment-quote
            </v-icon>
          </template>
          <span>Comentarios</span>
        </v-tooltip>
      </template>

    </v-data-table>
  </v-container>

  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        right
        absolute
        dark
        fab
        v-bind="attrs"
        v-on="on"
      >
        <v-icon dark>
          mdi-plus
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        link
        @click="newCliente"
      >
        <v-list-item-title>Agregar individual</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="isAdmin"
        link
        @click="uploadExcel"
      >
        <v-list-item-title>Agregar por Excel</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>

<!-- 
  <view-map-component
    ref="viewMap"
    @onDialog="onDialog"
  />

  <wait-gps-component
  :dialog-wait-gps="dialogWaitGps"
  >
  </wait-gps-component>

  <comentarios
    ref="comentarios"
    @onComentario="onComentario"
  /> -->

  <comentarios
    ref="comentarios"
    @onComentario="onComentario"
  />
  <new-cliente
    ref="newCliente"
    @onCreateCliente="onCreateCliente"
  />
  <dialog-personalizado
    ref="dialogDeleteCliente"
    @onDialog="onDialog"
  />

  <agregar-por-excel
    ref="uploadExcel"
    @onUploadExcel="onUploadExcel"
  />

  <wait-gps-component
  :dialog-wait-gps="dialogWaitGps"
  >
  </wait-gps-component>
</div>
</template>

<script>
import NewCliente from './components/NewClienteComponent.vue'
import Comentarios from './components/ClienteComentario.vue'
import DialogPersonalizado from '../components/Dialog.vue'
import AgregarPorExcel from './components/AgregarPorExcel.vue'
import WaitGpsComponent from './components/WaitGpsComponent.vue'
import moment from 'moment'

import xlsx from 'json-as-xlsx'

export default {
components: {
  NewCliente,
  DialogPersonalizado,
  Comentarios,
  AgregarPorExcel,
  WaitGpsComponent
},
data () {
  return {
    loading: true,
    clientes: [],
    search: '',
    isLoadingDownload: false,
    dialogWaitGps: false,
    headers: [
      { text: 'Nombre comercial', value: 'nombre_comercial' },
      { text: 'Razon social', value: 'razon_social' },
      { text: 'Ruc', value: 'ruc' },
      { text: 'Direccion', value: 'direccion_cliente' },
      { text: 'Departamento', value: 'departamento' },
      { text: 'Provincia', value: 'provincia' },
      { text: 'Tipo de cliente', value: 'tipo_de_cliente' },
      { text: 'Estado de negociacion', value: 'estado_de_negociacion' },
      { text: 'Canales de venta', value: 'canal_de_venta' },
      { text: 'Vendedor', value: 'email_user' },
      { text: 'N° Tienda', value: 'n_tienda' },
      { text: 'Perfil de cliente', value: 'perfil_de_cliente' },
      { text: 'Ultima visita', value: 'fecha_ultima_visita' },
      { text: 'Actualizacion', value: 'updated_at' },
      { text: 'Accions', value: 'accions' },
    ],
  }
},
computed: {
  isAdmin () {
    return JSON.parse(localStorage.userAuth).perfil !== 'Administrador' ? false : 'a'
  },

},

mounted () {
  this.getClientes()
},

methods: {
  async getClientes () { //{{url}}/api/distribuidores/prospectar
      this.clientes = []
  // console.log(JSON.parse(localStorage.userAuth).email)
      if (this.isAdmin) {
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/distribuidores/prospectar', {
                                    method: 'GET',
                                    headers: {
                                                'Content-type': 'application/json;charset=UTF-8',
                                                email_user: JSON.parse(localStorage.userAuth).email,
                                              }
                                  })
        const data = await response.json()
        if (data.success) {
          data.data.forEach(element => {
          const updatedAt = {
          ...element, 
          updated_at: moment(element.updated_at).format('YYYY-MM-DD HH:mm:ss'), 
          }
          this.clientes.push(updatedAt)
          })

          console.log(this.clientes)
          this.loading = false
        } else {
          this.loading = false
        }
      } else {
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/distribuidores/prospectar/user', {
                                    method: 'GET',
                                    headers: {
                                                'Content-type': 'application/json;charset=UTF-8',
                                                email_user: JSON.parse(localStorage.userAuth).email
                                              }
                                  })
        const data = await response.json()
        if (data.success) {
          this.clientes = data.data
          this.loading = false
        } else {
          this.loading = false
        }
      }
  },
  newCliente () {
    this.$refs.newCliente.open(undefined)
  },
  onCreateCliente () {
    this.getClientes()
  },
  editarCliente (item) {
    this.$refs.newCliente.open(item)
  },
  comentariosCliente (item) {
      this.$refs.comentarios.open(item)
  },
  onComentario () {
      this.getClientes()
  },
  dialogDelete (item) {
      this.$refs.dialogDeleteCliente.open('Eliminar cliente', '¿Esta seguro de eliminar cliente?', item)
  },
  onDialog (cliente) {
    this.eliminarEntidadTecnica(cliente)
  },
  async eliminarEntidadTecnica (cliente) {
    const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/distribuidores/prospectar/' + cliente.id, {
                                method: 'DELETE',
                                headers: {
                                            'Content-type': 'application/json;charset=UTF-8',
                                          }
                              })
    const data = await response.json()
    if (data.success) {
      this.getClientes()
    } else {
      this.getClientes()
    }
    this.$refs.dialogDeleteCliente.close()
  },
  uploadExcel () {
      this.$refs.uploadExcel.open()
  },
  onUploadExcel () {
      this.getClientes()
  },
  async exportarExcel () {
      try {
        this.isLoadingDownload = true
        const data = [
          {
            sheet: 'Campañas',
            columns: [
              { label: 'NOMBRE COMERCIAL', value: 'nombre_comercial' },
              { label: 'RUC', value: 'ruc' },
              { label: 'RAZON SOCIAL', value: 'razon_social' },
              { label: 'DEPARTAMENTO', value: 'departamento' },
              { label: 'PROVINCIA', value: 'provincia' },
              { label: 'TIPO DE CLIENTE', value: 'tipo_de_cliente' },
              { label: 'CANAL DE VENTA', value: 'canal_de_venta' },
              { label: 'ESTADO DE NEGOCIACION', value: 'estado_de_negociacion' },
              { label: 'EMAIL', value: 'email_user' },
              { label: 'N° TIENDA', value: 'n_tienda' },

              { label: 'TIPO DE TIENDA', value: 'tipo_de_tienda' },
              { label: 'PERFIL DE CLIENTE', value: 'perfil_de_cliente' },
              { label: 'FECHA ULTIMA VISITA', value: (row) => (moment(row).format('L') || '') },
              { label: 'ACTIVO', value: 'activo' },
              { label: 'LOGO', value: 'logo' },
              { label: 'LATITUD', value: 'latitud' },
              { label: 'LONGITUD', value: 'longitud' },
              { label: 'PRODUCTOS', value: 'productos' },
              { label: 'TIENE EXHIBIDOR', value: 'exhibidor' },
              { label: 'DEBE REMOLEDAR_EXHIBIDOR', value: 'remoledar_exhibidor' },
              { label: 'FOTO_LOCAL', value: 'foto_local' },
              { label: 'TIENE_MATERIAL', value: 'tiene_material' },
              { label: 'REDES SOCIALES', value: 'redes_sociales' },
              { label: 'WEB', value: 'web' },
              { label: 'LINK FACEBOOK', value: 'link_facebook' },
              { label: 'DIRECCION CLIENTE', value: 'direccion_cliente' },
              // { label: '', value: 'ubicacion_de_maps' },
            
            ],
            content: [
              ...this.clientes
            ]
          }]

        const settings = {
          sheetName: 'Data',
          fileName: 'Prospeccion'
        }

        await xlsx(data, settings)
        this.isLoadingDownload = false
      } catch (error) {
        this.isLoadingDownload = false
      }
    },
  agregarContactosCliente (item) {
      this.$router.push({ name: 'contactos de cliente', params: { cliente_id: item.id } })
  },
  verificarDireccion (item) {
    this.$router.push({ name: 'ubicacion de cliente', params: { item: item } })
  },
  computedDate (fecha) {
    return moment(fecha).format('L') 
  },
},
}
</script>

<style>
</style>
